import { toast } from 'react-toastify';

import {
  fetchEventConfig,
  createEventConfig,
  updateEventConfig
} from './services';

import {
  setIsLoading,
  setSchedulingConfiguration,
  clearSchedulingConfiguration
} from './actions';

export const loadEventConfig = (userId, establishmentId, options = {}) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchEventConfig(userId, establishmentId, options)
    .then(({ data }) => dispatch(setSchedulingConfiguration(data)))
    .catch(() => dispatch(clearSchedulingConfiguration()))
    .finally(() => dispatch(setIsLoading(false)));
}

export const upsertEventConfig = (userId, establishmentId, id, params) => dispatch => {
  dispatch(setIsLoading(true));

  if(!id) {
    return createEventConfig(userId, establishmentId, params)
      .then(({ data }) => {
        dispatch(setSchedulingConfiguration(data));
        toast.success('Disponibilidade configurada com sucesso.');
      })
      .catch(error => {
        if(error?.hasOwnProperty('weeklySettings')) {
          return toast.error(error['weeklySettings'][0]);
        }
  
        if(error?.hasOwnProperty('dayOfMonthSettings')) {
          return toast.error(error['dayOfMonthSettings'][0]);
        }

        toast.error('Houve um erro ao configurar a disponibilidade.');
      })
      .finally(() => dispatch(setIsLoading(false)));
  }

  return updateEventConfig(userId, establishmentId, params)
    .then(({ data }) => {
      dispatch(setSchedulingConfiguration(data));
      toast.success('Disponibilidade atualizada com sucesso.');
    })
    .catch(error => {
      if(error?.hasOwnProperty('weeklySettings')) {
        return toast.error(error['weeklySettings'][0]);
      }

      if(error?.hasOwnProperty('dayOfMonthSettings')) {
        return toast.error(error['dayOfMonthSettings'][0]);
      }

      toast.error('Houve um erro ao atualizar a disponibilidade.');
    })
    .finally(() => dispatch(setIsLoading(false)));
}